export class CalendarClassSelector {

   constructor(params, dm) {

      let defaults = {
         showMy: true,
         onChange: null
      };

      this.set = Object.extend(true, defaults, params);

      this.dm = dm;
      this.panel = document.createElement('div');
      this.panel.classList.add('class-selector');

      this.panelButtons = this.panel.createElement('div', 'buttons');
      this.panelClasses = this.panel.createElement('div', 'classes');

      this.buttonNone = this.panelButtons.createElement('div', 'button select-none');
      this.buttonNone.innerHTML = 'keine';
      this.buttonAll = this.panelButtons.createElement('div', 'button select-all');
      this.buttonAll.innerHTML = 'alle';

      if (this.set.showMy) {
         this.buttonMy = this.panelButtons.createElement('div', 'button select-my');
         this.buttonMy.innerHTML = 'meine'
         this.buttonMy.addEventListener('click', () => {
            this.select(this.dm.getMyClasses());
            this.triggerChange();
         });

      }

      this.buttonAll.addEventListener('click', () => {
         this.panelClasses.querySelectorAll('.toggle-button').addClass('selected');
         this.triggerChange();
      });
      this.buttonNone.addEventListener('click', () => {
         this.panelClasses.querySelectorAll('.toggle-button').removeClass('selected');
         this.triggerChange();
      });


   }

   select(classes) {
      this.panel.querySelectorAll('.toggle-button').forEach((item) => {
         if (classes.includes(parseInt(item.dataset.classId))) item.classList.add('selected');
         else item.classList.remove('selected');
      });
   }

   setClasses(cl, selected) {

      this.panelClasses.empty();
      selected = selected || 'all';

      let classes = Object.values(cl).filter(item => item.name.search(/^P\d$/) === -1);

      classes.sort((a,b) => {
         if (a.year != b.year) return a.year - b.year;
         if (a.ext < b.ext) return -1;
         if (a.ext > b.ext) return 1;
         return 0;
      });

      let row = 0, column = 1, currentYear = -1

      for (let cls of classes) {
         if (cls.year !== currentYear) {
            row++;
            column = 1;
            currentYear = cls.year;
         }
         let classElement = this.panelClasses.createElement('div', 'button toggle-button');
         if (selected.includes(cls.id) || selected === 'all') classElement.classList.add('selected');
         classElement.setStyles({'grid-area': `${row} / ${column} / span 1 / span 1`});
         classElement.innerHTML = cls.name;
         classElement.dataset.classId = cls.id;
         column++;
      }

      this.panel.querySelectorAll('.toggle-button').forEach((item) => {
         item.addEventListener('click', (event) => {
            event.currentTarget.classList.toggle('selected');
            this.triggerChange();
         });
      });


   }

   getSelected() {
      return Array.from(this.panelClasses.querySelectorAll('.button.selected'), item => parseInt(item.dataset.classId));
   }

   getHtmlElement() { return this.panel; }

   triggerChange() {
      if (this.set.onChange) this.set.onChange();
   }




}
